import {React} from "react";
import PublicLayout from "../components/layouts/PublicLayout";
import SignIn from "../modules/authentication/SignIn";
import SignUP from "../modules/authentication/SignUp";
import ForgotPassword from "../modules/authentication/ForgotPassword";
import Blog from "../modules/landing/Blog";
import ResetPassword from "../modules/authentication/ResetPassword";
import PatientResetPassword from "../modules/patient/addpatient/PatientResetPassword";
import ForgotHome from "../modules/authentication/ForgotHome";
import PatientRegistration from "../modules/patient/addpatient/PatientRegistration";
import SignInWithTempPassword from "../modules/authentication/SignInWithTempPassword";
import { Navigate } from "react-router";

const publicRoutes = [
	{
		path: "/",
		element: <Navigate to="/login" replace />
	},
	{
		path: "/login",
		exact: true,
		element: <PublicLayout><SignIn /></PublicLayout>
	},
	{
		path: "/login-temp",
		exact: true,
		element: <PublicLayout><SignInWithTempPassword /></PublicLayout>
	},
	{
		path: "/signUp",
		exact: true,
		element: <PublicLayout><SignUP/></PublicLayout>
	},
	{
		path: "/forgot-password",
		exact: true,
		element: <PublicLayout><ForgotPassword/></PublicLayout>
	},
	{
		path: "/forgot-home",
		exact: true,
		element: <PublicLayout><ForgotHome/></PublicLayout>
	},
	{
		path: "/reset-password",
		exact: true,
		element: <PublicLayout><ResetPassword/></PublicLayout>
	},
	{
		path: "/blog",
		exact: true,
		element: <PublicLayout><Blog/></PublicLayout>
	},
	{
		path: "/patient-reset-password",
		exact: true,
		element: <PublicLayout><PatientResetPassword/></PublicLayout>
	},
	{
		path: "/patient-registration",
		exact: true,
		element: <PublicLayout><PatientRegistration/></PublicLayout>
	}
	// { path: "/*", element: <SignIn/> },
];
export default publicRoutes;
